exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ibox i[data-v-71007b9e] {\n     color: #fff;\n     font-size: 11px;\n}\n.modal-header a[data-v-71007b9e] {\n    align-self: center;\n}\n.modal-header i[data-v-71007b9e] {\n     color: #495966;\n     font-size: 16px;\n     margin-left: 3px;\n}\n", ""]);

// exports
